<template>
  <div :style="cssVars" class="connect-feature" >
    <div class="flex center-all">
      <div class="number-icon" />
      <SBIcon
        class="arrows"
        :icon="SBIconList.ARROW_BIDIRECTION"
        :color="SBColors.greyPrimary"
        :size="18" />
      <div class="integration-icon" />
    </div>
    <p>{{ connectText }}</p>
    <p
      class="start"
      @click="start" >Get started now</p>
  </div>
</template>

<script>
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';

export default {
  name: 'ConnectFeature',
  components: {
    SBIcon,
  },
  props: {
    connectText: {
      type: String,
      required: false,
      default: '',
    },
    icon: {
      type: String,
      required: false,
      default: null,
    },
    image: {
      type: String,
      required: false,
      default: '',
    },
    iconBackground: {
      type: String,
      required: false,
      default: SBColors.greyPrimary,
    },
  },
  data() {
    return {
      SBIconList,
      SBColors,
    };
  },
  computed: {
    cssVars() {
      return {
        '--icon-background': this.iconBackground,
        '--icon': this.image ? `url(${this.image})` : `url('${this.iconPath}')`,
      };
    },
    iconPath() {
      // eslint-disable-next-line
      return this.icon ? require(`@/${this.icon}`) : '';
    },
  },
  methods: {
    start() {
      this.$emit('start');
    },
  },
};
</script>

<style lang="scss" scoped>
.connect-feature {
  margin-top: 50px;

  p {
    max-width: 360px;
    font-size: 16px;
    font-weight: normal;
    text-align: center;
    line-height: 1.2;
    color: #54626c;
    margin: 17px auto 0;

    &.start {
      font-size: 14px;
      font-weight: 500;
      color: #2680eb;
      cursor: pointer;

      &:hover {
        color: $blackPrimary;
      }
    }
  }
}

.number-icon {
  background-color: #f8f8ff;
  border-radius: 31px;
  box-shadow: 0 0 3px 0 rgba(48, 54, 70, 0.05);
  border: solid 1px $greyBorder;
  width: 45px;
  height: 45px;

  &::after {
    content: '';
    display: block;
    height: 44px;
    width: 44px;
    background-image: url('~@/assets/img/SB-Images/app-logo-transparent.png');
    background-size: 26px 26px;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.integration-icon {
  background-color: var(--icon-background);
  border-radius: 31px;
  box-shadow: 0 0 3px 0 rgba(48, 54, 70, 0.05);
  border: solid 1px $greyBorder;
  width: 45px;
  height: 45px;

  &::after {
    content: '';
    display: block;
    height: 44px;
    width: 44px;
    background-image: var(--icon);
    background-size: 22px 22px;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.arrows {
  margin: 0 14px;
}
</style>
